<template>
	<helio-empty
		:initial-title="title"
		class="table__empty-table"
		illustration="search"
	/>
</template>

<script>
import Empty from '../../empty/Empty.vue';

export default {
	name: 'EmptyTable',

	components: {
		'helio-empty': Empty,
	},

	props: {
		criterias: {
			type: Object,
			required: true,
		},
	},

	computed: {
		title() {
			if (this.hasSearch && this.hasFilters) {
				return this.$t('table.empty-table.search-and-filters', [this.criterias.search.term]);
			}

			if (this.hasSearch) {
				return this.$t('table.empty-table.search', [this.criterias.search.term]);
			}

			if (this.hasFilters) {
				return this.$t('table.empty-table.filters');
			}

			return this.$t('table.empty-table.others');
		},

		hasSearch() {
			return this.criterias.search && this.criterias.search.term;
		},

		hasFilters() {
			return this.criterias.filters;
		},
	},
};
</script>

<style lang="text/scss" src="./empty-table.scss" />
